import Utils from '@/ecm/common/Utils';
import SortType from '@/ecm/variables/SortType';
export default class SortItem {
    constructor () {
        this.uuid = Utils.object.getUUID();
        this.fieldTitle = '';
        this.sortOrder = SortType.Ascendent;
    }
}
